import script from "./ProjectMainInfoIcons.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectMainInfoIcons.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectMainInfoIcons.vue?vue&type=style&index=0&id=649aa556&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-649aa556"]])

export default __exports__